goog.provide('el8.core.service.UILayout');

goog.require('el8.util.base');
goog.require('el8.util.consts');
goog.require('el8.model.base');


/**
 * This object does the most basic management of a page's UI Layout, and
 * should be instantiated for every application page.  It provides
 * convenient methods to get the "height" and "width" of the
 * app's page, and also adds page-wide window resize listeners.
 *
 * For pages where this UILayout object is instantiated, there should be
 * NO calls to $(window).width(), or $(window).height(), or $(window).resize()
 */


el8.core.service.UILayout = function() {};
el8.core.service.UILayout.addEvents();


el8.core.service.UILayout.prototype.setup = function() {

    var that = this;

    // Gets triggered whenever the whole window resizes (implies the app must resize too)
    $(window).on('resize', _.debounce(function() { that.onResize(); },
        el8.util.consts.RESIZE_RATE));
    if ('onorientationchange' in window) {
        $(window).on('onorientationchange', that.onResize);
    }

    return this;
};

el8.core.service.UILayout.prototype.onResize = function() {
    this.trigger('el8_resizeApp');
};

/**
 * Use in place of $(window).on('resize', fn);
 */
el8.core.service.UILayout.prototype.addResizeListener = function(fn) {
    if (!fn) { return; }
    this.bind('el8_resizeApp', fn);
};

/**
 * Use in place of $(window).unbind('resize', fn);
 */
el8.core.service.UILayout.prototype.removeResizeListener = function(fn) {
    if (!fn) { return; }
    this.unbind('el8_resizeApp', fn);
};

el8.core.service.UILayout.prototype.getAppHeight = function() {
    return $(window).height();
};

el8.core.service.UILayout.prototype.getAppWidth = function() {
    return $(window).width();
};
